// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryCard_wrapper__mQ29S"};